import { useEffect, useState } from 'react';
import { useIntegratedForm } from '../../forms/use-integrated-form';
import { UnitHistoryForm } from '../types';

export function useIsUnitHistorySearchEmpty(): boolean {
    const { form } = useIntegratedForm<UnitHistoryForm>();
    const [isSearchEmpty, setIsSearchEmpty] = useState<boolean>(true);

    useEffect(() => {
        const subscription = form.watch((value) => {
            setIsSearchEmpty(
                (!value.unitOption && !value.userOption) ||
                    (value.timeRangeOption?.value === 'CUSTOM' && !value.dateRange)
            );
        });
        return () => subscription.unsubscribe();
    }, [form]);

    return isSearchEmpty;
}
